import appleWatch789 from '@/assets/device-icons/apple-watch-7-8-9.svg';

interface AppleWatch789IconProps {
  className?: string;
}

export const AppleWatch789Icon = ({ className = "h-5 w-5" }: AppleWatch789IconProps) => {
  return (
    <img 
      src={appleWatch789} 
      alt="Apple Watch Series 7/8/9" 
      className={className}
    />
  );
};
